// src/components/common/Breadcrumb.tsx
import React from "react";
import { Breadcrumb as AntBreadcrumb } from "antd";
import { Link } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";

interface BreadcrumbItem {
  title: React.ReactNode;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const breadcrumbItems = items.map((item, index) => ({
    title: item.href ? (
      <Link to={item.href} className="text-blue-600 hover:text-blue-800">
        {index === 0 ? (
          <>
            <HomeOutlined className="mr-1" />
            {item.title}
          </>
        ) : (
          item.title
        )}
      </Link>
    ) : (
      item.title
    ),
  }));

  return (
    <AntBreadcrumb items={breadcrumbItems} className="mb-6" separator=">" />
  );
};
